export const validateZipCode = (zipCode: string | undefined): boolean =>
  !!(zipCode && /^\d{5}$/.test(zipCode));

export const formatZip = (value: string) => {
  return value
    .trim()
    .replace('  ', ' ')
    .replace(/[^A-Z0-9\s']/gi, '') // replace all non-alphanumeric characters
    .toUpperCase();
};
